import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Grid, Paper, Tab, Tabs, Typography, useTheme } from "@mui/material";
import CustomBreadcrumbs from "../../../../components/breadcrumbs";
import SectionTitle from "../../../../components/sectionTitle";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import CashlessEconomyBasicInformation from './details/basicInformation';
import { getEconomyByUuid } from '../../../../controllers/company/cashless/EconomiesController';
import CashlessEconomyPOS from './details/pos';
import CashlessEconomyParticipants from './details/participants';
import Cashless from '..';
import CashlessTransactions from './details/transactions';


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ pt: 3, pb:3 }}>{children}</Box>}
      </div>
    );
  }
  
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }


export default function CashlessEconomyDetails()
{
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [economy,setEconomy] = useState([]);
    let { uuid } = useParams();

    useEffect(()=>{
        handleGetEconomy();
    },[]);
    
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleGetEconomy = async () => {
        const response = await getEconomyByUuid(uuid);
        if(response.success === true)
        {
            setEconomy(response.data.economy);
        }
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs crumbs={[{name:'Cashless',link:'/cashless/economies'}]} returnTo={"/"}/>
            <SectionTitle title={"Detalles Economia"}/>
            {/**Datos Generales del pedido */}
            <Grid container spacing={3} mt={-5}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Paper elevation={3}>
                        <Grid container spacing={3}>
                            {/**Datos del Pedido */}
                            <Grid item lg={6} xl={6}>
                                <Typography variant="h6" color={'cancel.dark'}>Nombre: <span style={{fontWeight:'bold',color:theme.palette.primary.main}}>{economy.name}</span></Typography>
                                <Typography variant="h6" color={'cancel.dark'}>Modo: <span style={{fontWeight:'bold',color:theme.palette.primary.main}}>{economy.mode}</span></Typography>
                                <Typography variant="h6" color={'cancel.dark'}>Tecnologia: <span style={{fontWeight:'bold',color:theme.palette.primary.main}}>{economy.technology}</span></Typography>
                                <Typography variant="h6" color={'cancel.dark'}>Tipo: <span style={{fontWeight:'bold',color:theme.palette.primary.main}}>{economy.type}</span></Typography>
                                <Typography variant="h6" color={'cancel.dark'}>Moneda: <span style={{fontWeight:'bold',color:theme.palette.primary.main}}>{economy.currency}</span></Typography>
                            </Grid>                            
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
            <Box sx={{ width: '100%',mt:5}}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label="Información General" {...a11yProps(0)} />
                        <Tab label="Participantes" {...a11yProps(1)} />
                        <Tab label="POS" {...a11yProps(2)} />
                        <Tab label="Tarjetas" {...a11yProps(3)} />
                        <Tab label="Transacciones" {...a11yProps(4)} />
                    </Tabs>
                </Box>
                
                <CustomTabPanel value={value} index={0}>
                    <CashlessEconomyBasicInformation economy={economy}/>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                    <CashlessEconomyParticipants economy={economy}/>
                </CustomTabPanel>
                
                <CustomTabPanel value={value} index={2}>
                    <CashlessEconomyPOS economy={economy}/>
                </CustomTabPanel>
                
                <CustomTabPanel value={value} index={3}>
                    Tarjetas
                </CustomTabPanel>
                
                <CustomTabPanel value={value} index={4}>
                    <CashlessTransactions economy={economy}/>
                </CustomTabPanel>
            </Box>
        </Container>
    )
}